import type {
  CreateQueryOptions,
  QueryClient,
  QueryKey,
} from '$lib/api/tanstack-query';

export interface PrefetchResult<DataT, ErrorT> {
  data: DataT | undefined;
  error: ErrorT | undefined;
}

/** Prefetch a query and return its data or error, if any. */
export const prefetchQuery = async <
  DataT,
  ErrorT = Error,
  QueryKeyT extends QueryKey = QueryKey,
>(
  queryClient: QueryClient,
  options: CreateQueryOptions<DataT, ErrorT, DataT, QueryKeyT>
): Promise<PrefetchResult<DataT, ErrorT>> => {
  if (options.enabled === false) {
    return { data: undefined, error: undefined };
  }

  await queryClient.prefetchQuery(options);
  const data = queryClient.getQueryData<DataT>(options.queryKey);
  const error =
    queryClient.getQueryState<DataT, ErrorT>(options.queryKey)?.error ??
    undefined;

  return { data, error };
};
